import React from "react";
import { Col, Row, Card } from 'react-bootstrap';

import EditButton from './EditButton'

const Component = (props) => {
  const { item } = props;
  
  return (
    <>
      <Card border="light" className="bg-white shadow-sm mb-4">
        <Card.Body>
          <Card.Header className="px-0">
            <Row className="align-items-center">
              <Col>
                <h6>{item.partner_title}</h6>
              </Col>
              <Col className="text-end">
                <EditButton item={item} />
              </Col>
            </Row>
          </Card.Header>
          <Row>
            <Col xs={12} className="py-2">
              <Row className="py-1">
                <Col xs={6} className="py-1">
                  <span className="fw-bold">Status</span>
                </Col>
                <Col xs={6} className="py-1">
                  <span className={`fw-normal ${(item.partner_account_status.toLowerCase() === 'active') && 'text-success'}`}>{item.partner_account_status}</span>
                </Col>
              </Row>
              <Row className="py-1">
                <Col xs={6} className="py-1">
                  <span className="fw-bold">Name</span>
                </Col>
                <Col xs={6} className="py-1">
                  <span className="fw-normal">{item.partner_name}</span>
                </Col>
              </Row>
              <Row className="py-1">
                <Col xs={6} className="py-1">
                  <span className="fw-bold">Website</span>
                </Col>
                <Col xs={6} className="py-1">
                  <span className="fw-normal text-blue text-decoration-none">
                    <a href={`${item?.partner_website}`} rel="noopener noreferrer">
                      {item?.partner_website}
                    </a>
                  </span>
                </Col>
              </Row>
            </Col>
          </Row>
        </Card.Body>
      </Card>
    </>
  );
};

export default Component;
